<template>
  <div class="mb-12">
    <v-row class="mx-0">
      <v-col class="px-0" cols="12">
        <fin-news-list v-if="hasNews"
                       :featuredItems="featuredNews"
                       :items="secondaryNews"
                       @loadMoreNews="loadAdditionalNews"/>
        <p v-else class="mb-12">Keine Nachrichten verfügbar</p>
      </v-col>
    </v-row>

    <fin-logo-full v-if="loading" dark loading/>

    <div v-if="!loading && nextToken !== null">
      <v-btn outlined @click="loadAdditionalNews">
        Mehr anzeigen
        <v-icon>icon-arrow-down</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import {finMasterDataAPI} from '@/js/finAPI'
import FinNewsList from '@/components/pages/finNews/newsList/index'
import FinLogoFull from '@/components/common/logo/LogoFull/index'

export default {
  name: 'FinAutoLoadMoreNewsList',
  components: {
    FinLogoFull,
    FinNewsList
  },
  props: {
    filter: {
      type: Object
    },
  },
  data() {
    return {
      news: [],
      nextToken: undefined,
      loading: true,
    }
  },
  computed: {
    hasNews() {
      return !!this.news?.length
    },
    featuredNews() {
      return this.hasNews ? [this.news[0]] : []
    },
    secondaryNews() {
      if (this.hasNews) {
        const result = [...this.news]
        result.shift()
        return result
      }
      return []
    },
  },
  methods: {
    async loadAdditionalNews() {
      if (this.nextToken !== null) {
        this.loading = true
        const result = await finMasterDataAPI.searchNewsTeasers(3, this.nextToken, this.filter)

        if (result === undefined) {
          console.error('no new news loaded')
          return
        }

        try {
          this.nextToken = result.nextToken
          this.news = [...this.news, ...result.items]
        } catch (e) {
          //TODO error handling
          console.error('failed to load next items', e)
        }

        this.loading = false
      }
    },
  },
  watch: {
    filter: {
      async handler() {
        await this.loadAdditionalNews()
      },
      deep: true,
      immediate: true
    },
  },
}
</script>

<style scoped>
</style>
